import { useLayoutEffect } from 'react';
import { noOpFn } from '../../private/helpers/noOpFn';

export const useLockBodyScroll = (locked: boolean): void => {
  useLayoutEffect(() => {
    if (locked) {
      // stash original body overflow
      const originalStyle = window.getComputedStyle(document.body).overflow;
      // prevent scrolling on mount
      document.body.style.overflow = 'hidden';

      return () => {
        // restore scrolling on unmount
        document.body.style.overflow = originalStyle;
      };
    }

    return noOpFn;
  }, [locked]);
};
